import { render, staticRenderFns } from "./DeliveryMethodLocked.vue?vue&type=template&id=106981d1&scoped=true"
import script from "./DeliveryMethodLocked.vue?vue&type=script&lang=js"
export * from "./DeliveryMethodLocked.vue?vue&type=script&lang=js"
import style0 from "./DeliveryMethodLocked.vue?vue&type=style&index=0&id=106981d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106981d1",
  null
  
)

export default component.exports